(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  // Connect popup triggers to their dialogs
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-popup-trigger]').forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const popupId = trigger.dataset.popupTrigger;
        const dialogComponent = document.querySelector(
          `.feature-popup-dialog[data-popup-id="${popupId}"]`
        );

        if (dialogComponent) {
          // Use the dialog-component's showDialog method
          const dialog = dialogComponent.querySelector('dialog');
          if (dialog) {
            dialog.showModal();
            dialogComponent.dispatchEvent(new CustomEvent('dialog:open'));
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
